import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../../../AuthProvider'
import { Query, collection, getDocs, orderBy, query, where } from 'firebase/firestore'
import SpecialisteComponent from '../../../components/SpecialisteComponent'
import { database } from '../../../firebaseConfig'

function ListService() {
    const { user } = useContext(AuthContext)
    const chu_user = user.chu_id
    const [services, setServices] = useState([])
    const listeChu_service = async () => {
        const res = []
        const q = query(collection(database, 'service_chu'), where('chu_id', "==", chu_user), where("status", "==", true))
        const chu_service_refs = await getDocs(q);
        const service_listes = await liste_service()
        chu_service_refs.forEach(chu_service => {
            const serviceFilter = service_listes.find(obj => obj.id == chu_service.data().service_id)
            res.push({
                ...serviceFilter
            })
        })
        setServices([...res])
    }
    const liste_service = async () => {
        const res = []
        const q = query(collection(database, 'service'), orderBy('nom_service', 'asc'))
        const service_refs = await getDocs(q);
        service_refs.forEach(serviceData => {
            res.push({
                id: serviceData.id,
                ...serviceData.data()
            })
        })
        return res
    }
    useEffect(() => {
        listeChu_service()
    }, [])

    return user && user.chu_id&&(
        <div style={{ width: '100%', flexGrow: 1, overflow: 'hidden' }}>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
                
                {services.map((data) => {
                    return (
                        <SpecialisteComponent data={data} changeSpecialiste={()=>{}} />
                    )
                })}

            </div>
        </div>
    )
}

export default ListService